var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"version5-head"},[(_vm.$store.state.selected_menu)?_c('LayoutHeadBanner',{attrs:{"itemData":_vm.$store.state.selected_menu}}):_vm._e()],1),_c('Breadcrumb'),(
      _vm._.get(
        _vm.$store.state.current_content,
        'secondary.InvestorsTabs.conf.enabled'
      ) == 1
    )?_c('InvestorsTabs'):_vm._e(),_c('div',{staticClass:"container layout-outer flex-box"},[_c('div',{staticClass:"layout-left"},[(_vm.$store.state.current_content)?_c('LayoutContent',{attrs:{"itemData":_vm.$store.state.current_content}}):_vm._e(),(
          _vm._.get(
            this.$store.state.current_content,
            'secondary.DropdownList.conf.enabled'
          ) == 1
        )?_c('DownloadList',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.DropdownList.data.0.smarttabs')}}):_vm._e()],1),_c('intersect',{on:{"enter":function($event){_vm.animate = true}}},[_c('div',{staticClass:"layout-right fadeUp",class:_vm.animate ? 'animate' : ''},[(
            _vm._.get(
              _vm.$store.state.current_content,
              'secondary.usefull_tools_right.conf.enabled'
            ) == 1
          )?_c('HowToApply',{attrs:{"itemData":_vm._.get(
              _vm.$store.state.current_content,
              'secondary.usefull_tools_right.conf'
            )}}):_vm._e(),(
            _vm._.get(
              this.$store.state.current_content,
              'secondary.custom_banner.conf.enabled'
            ) == 1
          )?_c('ApplicationLinkBoxHigh',{staticStyle:{"margin-bottom":"25px"},attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.custom_banner')}}):_vm._e()],1)])],1),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.ReasonsSlider.conf.enabled'
      ) == 1
    )?_c('ReasonsSlider',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.ReasonsSlider'),"noBg":'noBg'}}):_vm._e(),_c('MoreWaysForBanking')],1)}
var staticRenderFns = []

export { render, staticRenderFns }